import { Validators } from '@angular/forms';

import { EmailValidationError } from '../models/validation-errors.model';

/**
 * Validates an email address with reason-specific error codes.
 * Uses Angular's built-in email validator for RFC 5322 compliance.
 * @param value - Email string
 * @returns ValidationErrors with reason code or null if valid
 */
export function validateEmail(value: string): EmailValidationError | null {
  if (!value) return null;

  const trimmed = value.trim();

  // Basic format check - must contain @
  if (!trimmed.includes('@')) {
    return { email: { reason: 'missingAt' } };
  }

  const atIndex = trimmed.indexOf('@');
  const local = trimmed.substring(0, atIndex);
  const domain = trimmed.substring(atIndex + 1);

  // Check local part (before @)
  if (!local) {
    return { email: { reason: 'emptyLocal' } };
  }

  // Check domain part (after @)
  if (!domain) {
    return { email: { reason: 'emptyDomain' } };
  }

  // Domain must contain at least one dot
  if (!domain.includes('.')) {
    return { email: { reason: 'invalidDomain' } };
  }

  // Use Angular's email validator for full RFC 5322 check
  // Create a mock form control for the validator
  const mockControl = { value: trimmed } as { value: string };
  const angularResult = Validators.email(mockControl as never);

  if (angularResult) {
    return { email: { reason: 'format' } };
  }

  return null;
}
